export default __webpack_public_path__ + "static/media/ganarjuego4.30ab4f59.png";